import { useNavigate } from 'react-router';

import { PageWrapper } from 'src/components/PageWrapper';
import { APP_ROUTES } from 'src/constants/routes';
import { isEmbeddedPlatform } from 'src/features/config/AppEnvironmentDetector/utils';
import { ErrorInfo } from 'src/pages/teams/_components/AuthErrorView/ErrorInfo';

import { IllustrationServiceUnavailable } from '@/components/Illustration';

export const ServiceUnavailable = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper darkBackground={isEmbeddedPlatform()}>
      <div className="flex flex-1 flex-col items-center justify-center gap-12">
        <ErrorInfo
          description="Something went wrong. Please try again a few moments later."
          title="Service Unavailable"
          onClose={() => navigate(APP_ROUTES.HOME, { replace: true })}
        >
          <IllustrationServiceUnavailable className="max-w-480" />
        </ErrorInfo>
      </div>
    </PageWrapper>
  );
};
